import { useEffect, useRef } from "react";
import SiteWorkspace from "./SiteWorkspace";

/** A site, over the right edge of the register. The register stays where it
 * was underneath -- same filter, same page, same ticks -- so looking at a
 * site and coming back costs nothing. Escape, the backdrop and the close
 * button all close it; focus moves into it on open so the keyboard is where
 * the eyes are. */
export default function SiteDrawer({ id, onClose }: { id: number; onClose: () => void }) {
  const panel = useRef<HTMLElement>(null);

  useEffect(() => {
    panel.current?.focus();
  }, [id]);

  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.key === "Escape") {
        onClose();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} aria-hidden="true" />
      <aside ref={panel} className="drawer site-drawer" role="dialog" aria-modal="true" aria-label="Site" tabIndex={-1}>
        <SiteWorkspace id={id} onClose={onClose} />
      </aside>
    </>
  );
}
